import React from 'react';
import PropTypes from 'prop-types';

import { Card,Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  faTree,
} from '@fortawesome/free-solid-svg-icons';
import cloudCo2 from '@assets/img/markers/co2/icons8-co2-100.png';
import useEnergyData from './useEnergyData';
import styles from './EnergyData.module.less';
import IconInformation from '../IconInformation/IconInformation';
import CenteredContent from '@common/components/ui/CenteredContent';

function EnergyData() {

  const { t } = useTranslation();
  const { infoEnergy, infoEnvironmentData,loading } = useEnergyData();
  const {
    importEnergy,
    dischargeEnergy,
    storageEnergy,
    energyGenerated,
    exportEnergy,
    energySelfConsumption,
  } = infoEnergy;
  return (
    <div className={styles.wrapperContainer}>
       {(() => {
          if (loading) {
            return (
              <Card style={{ height: 'min-content', boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }}>
                <CenteredContent heightContainer="400px">
                  <Spin tip={t('views.device_graphics.loading_data_graphs')} />
                </CenteredContent>
              </Card>
            );
          }

          return (
            <>
              <div className={styles.wrapper}>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{dischargeEnergy}</h1>
                  {t('views.device_graphics.energy_state.total_imported_energy')}
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{storageEnergy}</h1>
                  {t('views.device_graphics.energy_state.total_energy_discharged')}
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{energySelfConsumption}</h1>
                  {t('views.device_graphics.energy_state.total_energy_stored')}
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{importEnergy}</h1>
                  {t('views.device_graphics.energy_state.co2_emissions_avoided')}
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{exportEnergy}</h1>
                  {t('views.device_graphics.energy_state.total_energy_consumed')}
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <h1>{energyGenerated}</h1>
                  {t('views.device_graphics.energy_state.total_exported_energy')}
                </Card.Grid>
              </div>
              <div className={styles.twoColumns}>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <div className={styles.CO2_text}>
                    <h1 className={styles.text_statistics}>{`${infoEnvironmentData.CO2} Kg`}</h1>
                  </div>
                  <div>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Solar details"
                      infoData=""
                      src={cloudCo2}
                      labelData={t('views.device_graphics.environment.CO2')}
                      isIcon={false}
                    />
                  </div>
                </Card.Grid>
                <Card.Grid style={{ boxShadow: '-2px 1px 6px 1px rgba(0, 0, 0, 0.08)' }} className={styles.wrapper_card_grid}>
                  <div className={styles.Trees_text}>
                    <h1 className={styles.text_statistics}>{`${infoEnvironmentData.TREES}`}</h1>
                  </div>
                  <div>
                    <IconInformation
                      className={styles.statusDeviceIconGeneral}
                      title="Info Solar details"
                      infoData=""
                      labelData={t('views.device_graphics.environment.Tree')}
                      icon={faTree}
                      isIcon
                    />
                  </div>
                </Card.Grid>
              </div>
            </>
          );
        })()}
    </div>
  );

}

EnergyData.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  className: PropTypes.string,
};

EnergyData.defaultProps = {
  className: null,
};

export default EnergyData;
